import { render, staticRenderFns } from "./TransactionTab.vue?vue&type=template&id=7358a076&scoped=true&"
import script from "./TransactionTab.vue?vue&type=script&lang=js&"
export * from "./TransactionTab.vue?vue&type=script&lang=js&"
import style0 from "./TransactionTab.vue?vue&type=style&index=0&id=7358a076&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7358a076",
  null
  
)

export default component.exports